// components/NewsletterSignup.tsx
import React, { useState } from 'react';
import { useLanguageContext } from '../context/LanguageContext';

const NewsletterSignup: React.FC = () => {
    const { isHE } = useLanguageContext();
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setStatus('loading');

        try {
            // Replace 'YOUR_FORM_ID' with your Formspree form ID
            const response = await fetch('https://formspree.io/f/mrbnavkz', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            if (response.ok) {
                setStatus('success');
                setEmail('');
                // Reset status after 3 seconds
                setTimeout(() => setStatus('idle'), 3000);
            } else {
                setStatus('error');
            }
        } catch (error) {
            setStatus('error');
        }
    };

    if (isHE) {
        return (
            <div className="bg-gray-800/50 backdrop-blur-md p-5 rounded-2xl border border-white/10 shadow-elevation-lg max-w-fit" dir="rtl">
                <h3 className="text-white mb-2 font-bold" style={{ color: "#F88158" }}>
                    הירשמו לעדכונים
                </h3>
                <p className="text-xs text-gray-300 mb-3">
                    קבלו התראה כשהאתר מתעדכן בפרופיל של פרוספקט חדש, או בכל תוכן אחר  
                </p>
                <form onSubmit={handleSubmit} className="flex gap-2">
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="your@email.com"
                        className="flex-1 px-3 py-2 rounded-xl bg-gray-700/80 text-white border border-gray-600 shadow-inner focus:border-orange-500 focus:ring-2 focus:ring-orange-500/40 focus:outline-none transition"
                        required
                        disabled={status === 'loading'}
                        dir="ltr"
                    />
                    <button
                        type="submit"
                        disabled={status === 'loading'}
                        className="px-4 py-2 rounded-xl font-bold shadow-elevation hover:brightness-110 active:scale-95 transition disabled:opacity-50"
                        style={{ backgroundColor: "#F88158" }}
                    >
                        {status === 'loading' ? '...' : 'הירשמו'}
                    </button>
                </form>
                {status === 'success' && (
                    <p className="text-green-400 text-sm mt-2">תודה! נעדכן אתכם בקרוב</p>
                )}
                {status === 'error' && (
                    <p className="text-red-400 text-sm mt-2">משהו השתבש, נסו שוב</p>
                )}
            </div>
        );
    }

    return (
        <div className="bg-gray-800/50 backdrop-blur-md p-5 rounded-2xl border border-white/10 shadow-elevation-lg max-w-md">
            <h3 className="text-white mb-2 font-bold" style={{ color: "#F88158" }}>
                Get Updates
            </h3>
            <p className="text-xs text-gray-300 mb-3">
                Be notified when a new prospect's profile, or any other content, is added
            </p>
            <form onSubmit={handleSubmit} className="flex gap-2">
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    className="flex-1 px-3 py-2 rounded bg-gray-700 text-white border border-gray-600 focus:border-orange-500 focus:outline-none"
                    required
                    disabled={status === 'loading'}
                />
                <button
                    type="submit"
                    disabled={status === 'loading'}
                    className="px-4 py-2 rounded font-bold transition-colors disabled:opacity-50"
                    style={{ backgroundColor: "#F88158" }}
                >
                    {status === 'loading' ? '...' : 'Subscribe'}
                </button>
            </form>
            {status === 'success' && (
                <p className="text-green-400 text-sm mt-2">Thanks! We'll keep you updated</p>
            )}
            {status === 'error' && (
                <p className="text-red-400 text-sm mt-2">Something went wrong, please try again</p>
            )}
        </div>
    );
};

export default NewsletterSignup;